import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';

export const useSliders = () => {
  const [sliders, setSliders] = useState([]);
  const { loading, error, get } = useApi();

  const fetchSliders = useCallback(async () => {
    const result = await get('/public/sliders');
    
    if (result.success) {
      setSliders(result.data);
    }
    
    return result;
  }, [get]);

  useEffect(() => {
    fetchSliders();
  }, [fetchSliders]);

  return {
    sliders,
    loading,
    error,
    fetchSliders,
  };
};

export default useSliders;
